module.exports = __webpack_public_path__ + "static/media/ld_default_banner_img.20291d3a.png";